// Debug HUD button — only mounted when ?previewToggle is on the URL.
// Cycles renderer.previewMode between 'camera-locked' (default;
// screen-locked, zero aim-time parallax) and 'plane-anchored' (preview
// follows ARCore hit's world position — has AR parallax while aiming,
// but the user sees exactly where the wheel will land).
//
// Positioned just above the track-mode toggle so both can coexist.

import { useState, useCallback } from 'react'

export type PreviewMode = 'camera-locked' | 'plane-anchored'

interface PreviewModeToggleProps {
  initialMode: PreviewMode
  onChange: (mode: PreviewMode) => void
}

export function PreviewModeToggle({
  initialMode,
  onChange,
}: PreviewModeToggleProps) {
  const [mode, setMode] = useState<PreviewMode>(initialMode)
  const cycle = useCallback(() => {
    const next: PreviewMode =
      mode === 'camera-locked' ? 'plane-anchored' : 'camera-locked'
    setMode(next)
    onChange(next)
  }, [mode, onChange])

  return (
    <button
      type="button"
      data-testid="preview-mode-toggle"
      onClick={cycle}
      style={{
        position: 'fixed',
        left: 12,
        bottom: 230,
        zIndex: 200,
        pointerEvents: 'auto',
        background: 'rgba(0, 0, 0, 0.85)',
        color: 'white',
        border: '1px solid rgba(255,255,255,0.25)',
        borderRadius: 999,
        padding: '10px 16px',
        fontSize: 12,
        fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
        cursor: 'pointer',
        boxShadow: '0 2px 6px rgba(0,0,0,0.35)',
      }}
    >
      PREV: {mode === 'camera-locked' ? 'CAMERA-LOCKED' : 'PLANE-ANCHORED'}
    </button>
  )
}
